module.exports = __webpack_public_path__ + "img/图片9-1.6f350157.png";